import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Link } from 'react-router-dom';


// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import TrainingStaffDate from './TrainingStaffDate';

class TrainingsCertificationModalEditInstructorsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      training_certification_id: this.props.training_certification_id,
      training_id: this.props.training_id,
      updated: this.props.updated,
      staffs: [],
      training_certification_id: '',
      modal: false,
      staff_id: false,
      hours: this.props.total_hours,
      message: '',
      deslocation_type: 1,
    };

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.ActionInputs = this.ActionInputs.bind(this);
    this.PresenceButtons = this.PresenceButtons.bind(this);
    this.confirmPresence = this.confirmPresence.bind(this);
    this.forceConfirmPresence = this.forceConfirmPresence.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_certification_id !== 'undefined' && Array.isArray(newProps.staffs) && Array.isArray(newProps.instructors_data)) || (this.state.loaded === 1 && newProps.updated === 1)){
      this.setState({
        hours: newProps.total_hours,
        training_id: newProps.training_id,
        training_certification_id: newProps.training_certification_id,
        staffs: newProps.staffs,
        instructors_data: newProps.instructors_data,
        loaded: 1,
      });
    }
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.state.staff_id,
      training_certification_id: this.state.training_certification_id,
      training_certification_type_id: 2,
      hours: this.state.hours,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado/instrutor', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.updateDataModal(responseJson);
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var training_certification_staff_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar o instrutor dessa aula?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/instrutor/' + training_certification_staff_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateDataModal(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  PresenceButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        {(this.props.status === 1 || this.props.status === 2) ?
          <div>
            {(row.attendance === 0) ?
              <button disabled className="btn btn-sm btn-danger"><i className="fa fa-fw fa-close"></i></button>
              :
              <button className="btn btn-sm btn-danger" onClick={() => {this.confirmAbsence(row.staff_id)}}><i className="fa fa-fw fa-close"></i></button>
            }
            {(row.attendance === 1) ?
              <button disabled className="btn btn-sm btn-success"><i className="fa fa-fw fa-check"></i></button>
              :
              <button className="btn btn-sm btn-success" onClick={() => {this.confirmPresence(row.staff_id)}}><i className="fa fa-fw fa-check"></i></button>
            }
          </div>
        :
          ''
        }
      </div>
    );

    return botao;
  }

  ActionInputs (cell, row) {
    var data = this.props.instructors_data;
    var date_start_str = this.props.date_start_str;
    var date_finish_str = this.props.date_finish_str;
    data.map(function(dado, index){
      if(cell === dado.id) {
        date_start_str = dado.date_start_str;
        date_finish_str = dado.date_finish_str;
      }
    });
    var botao = (
      <TrainingStaffDate training_certification_staff_id={cell} status={this.props.status} date_start={date_start_str} date_finish={date_finish_str} updateData={this.props.updateDataModal} handleAlert={this.props.handleAlert} />
    );

    return botao;
  }

  confirmAbsence (staff_id) {
    var confirm = window.confirm('Tem certeza que gostaria de confirmar a ausência do colaborador no treinamento?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_id: staff_id,
        training_id: this.props.training_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/confirmar/ausencia', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateDataModal({data: {training_certification_id: self.state.training_certification_id}, status: responseJson.status, message: responseJson.message});
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  confirmPresence (staff_id) {
    var confirm = window.confirm('Tem certeza que gostaria de confirmar a presença do colaborador no treinamento?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_id: staff_id,
        training_id: this.state.training_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/confirmar/presenca', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            if(responseJson.data === 'deslocation_alert'){
              self.setState({
                modal_staff: true,
                message: responseJson.message,
                staff_id: staff_id,
                force_change: 0,
              });
              self.props.handleAlert('', '', 'closed');
            } else {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');

            }
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  forceConfirmPresence (event) {
    event.preventDefault();
    var confirm = window.confirm('Tem certeza que gostaria de confirmar a presença do colaborador no treinamento?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_id: this.state.staff_id,
        training_id: this.state.training_id,
        deslocation_type: this.state.deslocation_type,
        force_change: 1,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/confirmar/presenca', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');

          }
          self.setState({
            modal_staff: false,
            staff_id: false,
            force_change: 0,
          });
    }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Adicionar instrutor</h3>
  <hr/>
  <form onSubmit={this.add}>
    <div className="form-group">
      <label>Instrutor:</label>
      <Select
        className="form-field-name"
        name="staff_id"
        value={this.state.staff_id}
        searchable={true}
        placeholder={'Selecionar instrutor'}
        onChange={this.handleSelectChange.bind(this, 'staff_id')}
        options={this.state.staffs}
        required
      />
    </div>
    <div className="form-group">
      <label>Carga horária:</label>
      <InputMask value={this.state.hours}  maskChar={null} name="hours" mask="99" className="form-control" onChange={this.handleChange.bind(this, 'hours')} placeholder="Preencha a carga horária" required />
    </div>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-plus"></i> Adicionar instrutor</button>
  </form>
  <hr/>
  <h3 className="page-title">Lista de instrutores</h3>
  <hr/>
    <BootstrapTable data={this.props.instructors_data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há certificados cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

      <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>

      <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Instrutor</TableHeaderColumn>

      <TableHeaderColumn dataField="hours" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='90'>Horas</TableHeaderColumn>

      <TableHeaderColumn dataField="certification_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Certificado</TableHeaderColumn>

      <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionInputs} width='500'>Período</TableHeaderColumn>

      <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.PresenceButtons} width='120'>Presença</TableHeaderColumn>

      <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>Ações</TableHeaderColumn>

    </BootstrapTable>

    <Modal show={this.state.modal_staff} aria-labelledby="contained-modal-title-md" bsSize={'medium'}>
    <Modal.Header>
      <h4 className="pull-left">{self.state.message}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_staff: false})}}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <p>O colaborador encontra-se de folga e sua residência está em uma cidade diferente do treinamento.</p>
      <p>O colaborador irá por meios próprios?</p>
      <br/>
      <form onSubmit={this.forceConfirmPresence}>
        <div className="row">
          <div className="col-md-12 form-group">
            <Select
              className="form-field-name"
              name="deslocation_type"
              value={this.state.deslocation_type}
              searchable={true}
              placeholder={'Selecionar meio de transporte'}
              onChange={this.handleSelectChange.bind(this, 'deslocation_type')}
              options={[
                {value: 1, label: 'Sim'},
                {value: 2, label: 'Não'},
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 form-group">
            <button type={'submit'} className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Enviar resposta</button>
          </div>
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_staff: false})}}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default TrainingsCertificationModalEditInstructorsTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingsCertificationModalEditInstructorsTab.js